import React from 'react'
import { Box } from '@mui/material'
import { EntryData } from './EntryData'
import Tooltip from '@mui/material/Tooltip'

interface ResolutionDataBadgeProps {
  title: string
  query?: string
  tooltipTitle?: string
  dataClass?: string
  color: string
}

export const ResolutionDataBadge: React.FC<ResolutionDataBadgeProps> = ({
  title,
  query = '',
  tooltipTitle,
  dataClass = 'DataBadge',
  color,
}) => {
  return (
    <Tooltip title={query.length > 0 ? '' : tooltipTitle} arrow>
      <Box
        className='NamespaceContainer'
        border={`0.9px solid ${color}`}
        height='16px !important'
      >
        <Box
          position='absolute'
          top={0}
          left={0}
          bottom={0}
          right={0}
          height='100%'
          width='100%'
          bgcolor={color}
          sx={{
            opacity: 0.2,
            zIndex: 1
          }}
        />
        <EntryData
          resource='namespace'
          name={title}
          query={query}
          dataClass={dataClass}
          zIndex={2}
        />
      </Box>
    </Tooltip>
  )
}
